import React from 'react';

const Friend = ({
    name,
    content,
    image,
}) => {
    const path = '/images/friends/'
    return (
        <div className='friend max-w jc-sb'>
            <div className='content-container flex col'>
                <h3>{name}</h3>
                <p>{content}</p>
            </div>
            <img src={path + image} alt={name + ' review'} />
        </div>
    );
};

export default Friend;